import script from "./platform.vue?vue&type=script&setup=true&lang=ts"
export * from "./platform.vue?vue&type=script&setup=true&lang=ts"

import "./platform.vue?vue&type=style&index=0&id=251487e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251487e8"]])

export default __exports__